module.exports = __webpack_public_path__ + "static/media/Microsoft_logo.8307ca44.svg";